module.exports = __webpack_public_path__ + "img/shop1-2.8618a245.png";